import CandidateTestAnswer from '@/orm/models/Candidate/CandidateTestAnswer';
import BaseModel from '../BaseModel';

export default class Question extends BaseModel {
  static entity = 'question';

  static fields() {
    return {
      id: this.attr(null),
      answers: this.attr(null),
      image: this.attr(null),
      order: this.attr(null),
      question: this.string(null).nullable(),
      score: this.attr(null),
      testId: this.attr(null),
      type: this.string(null).nullable(),
      candidateAnswers: this.hasMany(CandidateTestAnswer, 'testQuestionId'),
    };
  }

  static apiConfig = {
    actions: {
      createQuestion(id, testId, payload) {
        return this.post(`vacancies/${id}/test/${testId}/question`, payload);
      },
      updateQuestion(id, testQuestionId, payload) {
        return this.patch(`vacancies/${id}/test/question/${testQuestionId}`, payload);
      },
      deleteQuestion(id, testQuestionId) {
        return this.delete(`vacancies/${id}/test/question/${testQuestionId}`, { delete: testQuestionId });
      },
      uploadQuestionImage(testQuestionId, payload) {
        return this.post(`vacancies/test/${testQuestionId}/upload_image`, payload);
      },
      deleteQuestionImage(testQuestionId) {
        return this.delete(`vacancies/test/${testQuestionId}/upload_image`, { save: false });
      },
    },
  }
}
